import React from 'react';
import PropTypes from 'prop-types';

import defaultStyles from './LoadingSpinner.module.scss';

const LoadingSpinner = ({ styles }) => (
    <div className={ styles.loadingSpinner }>
        <div />
        <div />
        <div />
        <div />
    </div>
);

LoadingSpinner.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string)
};

LoadingSpinner.defaultProps = {
    styles: defaultStyles
};

export default LoadingSpinner;
